export const PCMBACKEND = "pcmbackend";
export const NAVISION = "navision";
export const ZAMMAD = "zammad";
